const CHARSET = "#$0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
export const START = CHARSET[0]
export const END = CHARSET[CHARSET.length - 1]
const LEN = CHARSET.length
const RANK_MIN = CHARSET[0]
const CHAR_MAP = (() => {
    const map: Record<string, number> = {}
    CHARSET.split("").forEach((e, i) => (map[e] = i))
    return map
})()

const MIDDLE_CHAR = CHARSET[Math.floor((CHARSET.length - 1) / 2)]
const MIDDLE_FRAC = CHAR_MAP[MIDDLE_CHAR]

const strsToFractions = (startStr: string, endStr: string) => {
    const diff = startStr.length - endStr.length

    // Pad values with "a" so they have equal length
    if (diff > 0) {
        endStr = endStr.padEnd(startStr.length, RANK_MIN)
    } else if (diff < 0) {
        startStr = startStr.padEnd(endStr.length, RANK_MIN)
    }

    // convert strings to number arrays and pad with 0 at the beginning for addition overflow
    const start = startStr.split("").map((char) => CHAR_MAP[char])
    const end = endStr.split("").map((char) => CHAR_MAP[char])

    return [start, end]
}

const fracToStr = (frac: number[]) => {
    return frac.map((digit) => CHARSET[digit]).join("")
}

const sumFractions = (start: number[], end: number[]) => {
    start = [0, ...start]
    end = [0, ...end]

    const result: number[] = new Array(end.length).fill(0)

    // start and end should be equal lengths

    for (let i = end.length - 1; i > 0; i--) {
        const [a, b] = [start[i], end[i]]
        result[i] += a + b
    }

    if (result[0] === 0) result.shift()

    return result
}

const divideFraction = (dividend: number[], divisor = 2) => {
    const quotient: number[] = Array(dividend.length).fill(0)
    let remainder = 0

    dividend.forEach((digit, i) => {
        const current = digit + remainder * LEN

        const quotientDigit = Math.floor(current / divisor)
        remainder = current % divisor

        quotient[i] = quotientDigit
    })

    for (let i = quotient.length - 1; i > 0; i--) {
        if (quotient[i] >= LEN) {
            quotient[i - 1] += Math.floor(quotient[i] / LEN)
            quotient[i] %= LEN
        }
    }

    return [quotient, remainder] as [number[], number]
}

export const createIndexBetween = (index1: string, index2: string) => {
    const [frac1, frac2] = strsToFractions(index1, index2)
    const sum = sumFractions(frac1, frac2)
    const [quotient, remainder] = divideFraction(sum)
    if (remainder && quotient.every((digit, i) => digit === frac1[i])) quotient.push(MIDDLE_FRAC)
    return fracToStr(quotient)
}
